import React, { FC } from 'react';
import styles from './GooglePhotosIcon.scss';

export const GooglePhotosIcon: FC = () => <div className={styles.googlePhotosIcon} />;
